/* eslint-disable react/jsx-no-useless-fragment */
import React, { useEffect, useState } from "react";
import {
  Box,
  CircularProgress,
  IconButton,
  Menu,
  MenuItem,
  TextField,
  Modal,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Typography,
  Divider,
  useMediaQuery,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import formService from "services/feedback-service";

export default function SelectTransType({
  label,
  placeholder,
  name,
  value,
  onChange,
  onBlur,
  errorFormik,
  helperText,
  disabled,
}) {
  const [clientTypes, setClientTypes] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedClientType, setSelectedClientType] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [openModal, setOpenModal] = useState(false);

  // Detect if mobile
  const isMobile = useMediaQuery("(max-width:600px)");

  useEffect(() => {
    setLoading(true);
    formService
      .getAllClientTypes()
      .then((response) => {
        // console.log(response);
        setClientTypes(response);
        setSelectedClientType(response.find((t) => t.id === value) || null);
      })
      .catch((err) => setError(err.message))
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    setSelectedClientType(clientTypes?.find((t) => t.id === value) || null);
  }, [clientTypes, value]);

  const handleClick = (event) => {
    if (isMobile) {
      setOpenModal(true);
    } else {
      setAnchorEl(event.currentTarget);
    }
  };

  const handleClose = (newValue) => {
    setAnchorEl(null);
    setOpenModal(false);
    if (newValue) {
      onChange?.(name, newValue.id || "");
      setSelectedClientType(newValue);
    }
  };

  const handleClear = () => {
    onChange?.(name, "");
    setSelectedClientType(null);
  };

  return (
    <Box>
      <TextField
        label={error ? `${label} - ${error}` : label}
        placeholder={error ? `${placeholder} - ${error}` : placeholder}
        name={name}
        variant="outlined"
        size="small"
        disabled={error || disabled}
        value={selectedClientType && value ? selectedClientType.type : ""}
        onClick={handleClick}
        onBlur={onBlur}
        error={errorFormik}
        helperText={helperText}
        sx={{
          width: "100%",
          mb: 2,
          fontSize: { xs: "0.875rem", sm: "1rem", xl: "1rem" },
          "& .MuiInputBase-root": {
            fontSize: { xs: "0.875rem", sm: "1rem", xl: "1rem" },
            "@media (min-height: 1080px)": {
              fontSize: "1rem",
            },
          },
          "& .MuiInputLabel-root": {
            fontSize: { xs: "0.75rem", sm: "0.875rem", xl: "1rem" },
            "@media (min-height: 1080px)": {
              fontSize: "1rem",
            },
          },
          "& .MuiFormHelperText-root": {
            fontSize: { xs: "0.7rem", sm: "0.8rem", xl: "1rem" },
            "@media (min-height: 1080px)": {
              fontSize: "1rem",
            },
          },
        }}
        InputProps={{
          endAdornment: (
            <>
              {loading ? (
                <CircularProgress color="inherit" size={20} />
              ) : (
                <>
                  {selectedClientType && (
                    <IconButton edge="end" onClick={handleClear}>
                      <CloseIcon />
                    </IconButton>
                  )}
                  {!disabled && !error && (
                    <IconButton edge="end" onClick={handleClick}>
                      <ArrowDropDownIcon />
                    </IconButton>
                  )}
                </>
              )}
            </>
          ),
        }}
      />

      {/* Normal Menu for Desktop */}
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => handleClose(null)}
      >
        <Typography
          sx={{
            px: 2,
            py: 1,
            fontWeight: "bold",
            fontSize: "0.9rem",
          }}
        >
          Select a Transaction Type
        </Typography>
        <Divider />
        {clientTypes.map((t, index) => (
          <div key={t.id}>
            <MenuItem
              sx={{
                width: "100%",
                fontSize: { xs: "0.8rem", xl: "1rem" },
                "@media (min-height: 1080px)": {
                  fontSize: "1rem",
                },
              }}
              onClick={() => handleClose(t)}
            >
              {t.type}
            </MenuItem>
            {index !== clientTypes.length - 1 && <Divider />}
          </div>
        ))}
      </Menu>

      {/* Scrollable Modal for Mobile */}
      <Modal open={openModal} onClose={() => setOpenModal(false)}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "80%",
            maxHeight: "60vh",
            overflowY: "auto",
            bgcolor: "background.paper",
            boxShadow: 24,
            // borderRadius: "10px",
            p: 3,
          }}
        >
          {/* Header */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Typography sx={{ fontWeight: "bold", fontSize: "1rem" }}>
              Select a Transaction Type
            </Typography>
            <IconButton onClick={() => setOpenModal(false)}>
              <CloseIcon />
            </IconButton>
          </Box>
          {/* <Divider sx={{ mb: 1 }} /> */}

          <List>
            {clientTypes.map((t, index) => (
              <div key={t.id}>
                <ListItem disablePadding>
                  <ListItemButton onClick={() => handleClose(t)}>
                    <ListItemText
                      primary={t.type}
                      sx={{ fontSize: "0.8rem" }}
                    />
                  </ListItemButton>
                </ListItem>
                {index !== clientTypes.length - 1 && <Divider />}
              </div>
            ))}
          </List>
        </Box>
      </Modal>
    </Box>
  );
}
